import { useField } from 'react-final-form'
import { FieldValidator } from 'final-form'
import { useTranslation } from 'react-i18next'
import { TextFieldProps } from '@mui/material/TextField'
import { composeValidators, textRequired } from '../../util/validate'

type FieldRequired = boolean | { showAsterisk?: boolean; triggedValidate?: boolean; errorMessage?: string }
type TextfieldProps = {
    name: string
    required?: FieldRequired
    validates?: FieldValidator<any>[]
    materialInputProps?: TextFieldProps
    maxLength?: number
    min?: number
    isDraftNotRequire?: boolean
    type?:
        | 'button'
        | 'checkbox'
        | 'color'
        | 'date'
        | 'datetime-local'
        | 'email'
        | 'file'
        | 'hidden'
        | 'image'
        | 'month'
        | 'number'
        | 'password'
        | 'radio'
        | 'range'
        | 'reset'
        | 'search'
        | 'submit'
        | 'tel'
        | 'text'
        | 'time'
        | 'url'
        | 'week'
    handleValueChange?: (event: string) => void
    onEnter?: () => void
    icon?: any
    defaultValue?: string | number
    resetButtom?: boolean
}

const useRichTextfield = (props: TextfieldProps) => {
    const { name, required, validates = [] } = props
    const { t } = useTranslation()

    let mergeValidate = validates
    if ((typeof required === 'boolean' && required) || (typeof required === 'object' && required.triggedValidate)) {
        mergeValidate = [
            textRequired(typeof required === 'object' ? required.errorMessage : `${t('LABEL.TEXT_REQUIRED')}`),
            ...mergeValidate,
        ]
    }
    /* Validate */
    const field = useField<string>(name, {
        validate: composeValidators(...mergeValidate),
    })

    return { field }
}

export default useRichTextfield
